module.exports = __webpack_public_path__ + "img/no-avatar-image-female.e48d3c56.jpg";